import { RouteComponentProps } from 'react-router';
import { connect, useDispatch, useSelector } from 'react-redux';
import * as formActions from '../../actions';
import * as organisationSelector from '../../../organisation/selectors/organisation';
import * as formsSelector from '../../selectors';
import type { StoreState } from '@common/types/store';
import Submissions from '@modules/forms/components/submissions/submissions';
import React, { memo, useCallback } from 'react';

const SubmissionsWithNotificationSetting = memo((props: any) => {
  const formId = props?.match?.params?.id;
  const dispatch = useDispatch();
  const userId = useSelector((state: StoreState) => state.loggedUser)?.user?.id;
  const setEnabled = useCallback((enabled: boolean) => {
    dispatch({
      type: 'forms/SET_USER_FORM_NOTIFICATION_SETTINGS',
      userId,
      formId,
      enabled
    });
  }, [formId, userId, dispatch]);
  return <Submissions
    {...props}
    setLoggedUserNotificationsEnabled={setEnabled}
  />;
});

type Params = {
  id: string;
  submissionId?: string;
};

type RouteProps = RouteComponentProps<Params>;

const mapStateToProps = (state: StoreState, { match }: RouteProps) => ({
  organisation: organisationSelector.selected(state),
  networks: organisationSelector.networks(state),
  functions: organisationSelector.functions(state),
  languageLocales: state.language.available,
  selectedForm: formsSelector.getForm(state, match.params.id),
  submissions: formsSelector.getSubmissions(state, match.params.id),
  submission: typeof match.params.submissionId === 'string' ?
    formsSelector.getSubmission(state, match.params.submissionId) :
    null,
  submissionMeta: typeof match.params.submissionId === 'string' ?
    formsSelector.getSubmissionMeta(state, match.params.submissionId) :
    null
});

const mapDispatchToProps = {
  fetchSubmissions: formActions.fetchSubmissions,
  downloadSubmissions: formActions.downloadSubmissions,
  fetchSubmission: formActions.fetchSubmission,
  updateSubmissionStatus: formActions.updateSubmissionStatus,
  deleteSubmission: formActions.deleteSubmission
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export const SubmissionsContainer = connector(SubmissionsWithNotificationSetting);
